import appGlobalScript from 'D:/a/1/s/Xperience/wwwroot/micrositeui/src/global/app.ts';
export const globalScripts = appGlobalScript;
